const getErrorMessage = (error) => {
  if (
    error
    && typeof error === 'object'
    && error?.type === 'ServerError'
    && Array.isArray(error.errors)
    && error.errors.length > 0
  ) {
    const first = error.errors[0];
    if (typeof first === 'string') {
      return first;
    }
    return null;
  }

  return null;
};

const getFingerprint = ({ error, event }) /* : string[] | null */ => {
  const message = error?.message || error || '';
  if (
    message === 'A network error occurred'
    || message === 'Request aborted'
    || message === 'Network Error'
    || message === 'Failed to fetch'
    || message === 'cancelado'
    || message === 'The fetching process for the media resource was aborted by the user agent at the user\'s request.'
    || message === 'TypeError: Load failed'
  ) {
    return ['network-problem'];
  }

  if (
    message === /Loading CSS chunk \d+ failed/.test(message)
    || /Loading chunk \d+ failed/.test(message)
  ) {
    return ['error-loading-chunk'];
  }

  const handledBy = event?.extra?.handledBy;

  if (handledBy === 'useNoodleApi' || handledBy === 'handlePageRequest' || handledBy === 'requestWithCatch') {
    const errorType = error?.type || 'UnknownError';
    return [
      event?.extra?.method,
      event?.extra?.routePath,
      getErrorMessage(error),
      errorType,
      '{{ default }}',
    ].filter(s => Boolean(s));
  }

  if (event?.tags?.flow) {
    return [`flow:${event.tags.flow}`, '{{ default }}'];
  }

  return null;
};

export default getFingerprint;
